import { styled } from 'lib/ui';

export const AddressButtons = styled.div.attrs({ className: 'AddressButtons' })`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65) !important;
  margin-top: ${p => p.theme.space};
`;
//   margin-top: ${p => p.theme.space};
